import { useState } from 'react';

import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

const useGetELabelShipmentBinary = () => {
  const addError = useError();
  const [{ loading }, makeRequest] = useImperativeRequestWrapper('shipment');
  const [data, setData] = useState<string | null>(null);

  const fetch = async (id) => {
    const { error, data } = await makeRequest({
      path: `/shipments/${id}/elabel/binary?format=BMP`,
      method: 'get',
      responseType: 'blob',
    });
    if (error) {
      addError(error);

      return { success: false };
    }

    // Convert blob to base64 using FileReader
    const reader = new FileReader();
    const base64Promise = new Promise<string>((resolve) => {
      reader.onloadend = () => {
        const base64String = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64String);
      };
    });

    reader.readAsDataURL(data);
    const processedData = await base64Promise;
    setData(processedData);
  };

  return {
    fetch,
    data,
    loading,
  };
};
export default useGetELabelShipmentBinary;
